import { library } from "@fortawesome/fontawesome-svg-core";

import { faBallotCheck as fasBallotCheck } from "@fortawesome/pro-solid-svg-icons/faBallotCheck";
import { faBellOn as fasBellOn } from "@fortawesome/pro-solid-svg-icons/faBellOn";
import { faChevronRight as fasChevronRight } from "@fortawesome/pro-solid-svg-icons/faChevronRight";
import { faCircleCheck as fasCircleCheck } from "@fortawesome/pro-solid-svg-icons/faCircleCheck";
import { faCircleChevronRight as fasCircleChevronRight } from "@fortawesome/pro-solid-svg-icons/faCircleChevronRight";
import { faCircleExclamation as fasCircleExclamation } from "@fortawesome/pro-solid-svg-icons/faCircleExclamation";
import { faCircleInfo as fasCircleInfo } from "@fortawesome/pro-solid-svg-icons/faCircleInfo";
import { faDesktop as fasDesktop } from "@fortawesome/pro-solid-svg-icons/faDesktop";
import { faTriangleExclamation as fasTriangleExclamation } from "@fortawesome/pro-solid-svg-icons/faTriangleExclamation";

import { faCalendarExclamation as farCalendarExclamation } from "@fortawesome/pro-regular-svg-icons/faCalendarExclamation";
import { faCheckCircle as farCheckCircle } from "@fortawesome/pro-regular-svg-icons/faCheckCircle";
import { faChevronLeft as farChevronLeft } from "@fortawesome/pro-regular-svg-icons/faChevronLeft";
import { faChevronRight as farChevronRight } from "@fortawesome/pro-regular-svg-icons/faChevronRight";
import { faCircleCheck as farCircleCheck } from "@fortawesome/pro-regular-svg-icons/faCircleCheck";
import { faCircleInfo as farCircleInfo } from "@fortawesome/pro-regular-svg-icons/faCircleInfo";
import { faClock as farClock } from "@fortawesome/pro-regular-svg-icons/faClock";
import { faDesktop as farDesktop } from "@fortawesome/pro-regular-svg-icons/faDesktop";
import { faDoNotEnter as farDoNotEnter } from "@fortawesome/pro-regular-svg-icons/faDoNotEnter";
import { faEnvelope as farEnvelope } from "@fortawesome/pro-regular-svg-icons/faEnvelope";
import { faListUl as farListUl } from "@fortawesome/pro-regular-svg-icons/faListUl";
import { faMagnifyingGlass as farMagnifyingGlass } from "@fortawesome/pro-regular-svg-icons/faMagnifyingGlass";
import { faPaperPlane as farPaperPlane } from "@fortawesome/pro-regular-svg-icons/faPaperPlane";
import { faTrashCan as farTrashCan } from "@fortawesome/pro-regular-svg-icons/faTrashCan";
import { faUserCircle as farUserCircle } from "@fortawesome/pro-regular-svg-icons/faUserCircle";
import { faLock as farLock } from "@fortawesome/pro-regular-svg-icons/faLock";

import { faBallotCheck as falBallotCheck } from "@fortawesome/pro-light-svg-icons/faBallotCheck";
import { faChevronRight as falChevronRight } from "@fortawesome/pro-light-svg-icons/faChevronRight";
import { faDesktop as falDesktop } from "@fortawesome/pro-light-svg-icons/faDesktop";

export const FontAwesomeLibrary = {
  init: () =>
    library.add(
      // solid
      fasBallotCheck,
      fasBellOn,
      fasChevronRight,
      fasCircleCheck,
      fasCircleChevronRight,
      fasCircleExclamation,
      fasCircleInfo,
      fasDesktop,
      fasTriangleExclamation,

      // regular
      farCalendarExclamation,
      farCheckCircle,
      farChevronLeft,
      farChevronRight,
      farCircleCheck,
      farCircleInfo,
      farClock,
      farDesktop,
      farDoNotEnter,
      farEnvelope,
      farListUl,
      farMagnifyingGlass,
      farPaperPlane,
      farTrashCan,
      farUserCircle,
      farLock,

      // light
      falBallotCheck,
      falChevronRight,
      falDesktop
    ),
};
